var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"jumbotron mt-5"},[_c('div',{staticClass:"col-sm-8 mx-auto"},[_c('h1',{staticClass:"text-center"},[_vm._v("BrandMax WS")]),_vm._v(" "),(_vm.remainingTime)?_c('div',{staticClass:"text-center mt-3"},[_c('h1',[_vm._v(_vm._s(_vm.remainingTime))])]):_vm._e()])]),_vm._v(" "),_c('div')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3165bd2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 